import { useParams, Navigate } from "react-router-dom";
import { useLang } from "@/App";
import { all, pick, seq } from "@/data/images";
import Hero from "@/components/Hero";
import GaleriaGrid from "@/components/GaleriaGrid";
import { Reveal, Pretitulo } from "@/components/Reveal";

export default function GaleriaCategoria() {
  const { cat } = useParams();
  const { t } = useLang();
  const p = t.fotos;
  const catData = p.categorias.find((c) => c.to === `fotos/${cat}`);
  const textos = p.galerias[cat];
  if (!catData || !textos) return <Navigate to={`/${t.lang}/fotos`} replace />;

  const TEXTOS_EXTRA = {
    'caminos-del-agua': t.actividades.caminos.descripcion,
    'pinturas-rupestres': t.actividades.pinturas.descripcion,
    'cabalgata-corralito': t.actividades.cabalgata.descripcion,
    'eventos-sociales': t.eventoTipo.sociales.presentacion.p1,
    'eventos-empresariales': t.eventoTipo.empresariales.presentacion.p1,
    'produccion': t.servicios.produccion.apoyo,
  };
  const textoCompleto = textos.texto || TEXTOS_EXTRA[cat] || '';

  const hero = pick(catData.hero[0], 0) || all(catData.hero[0])[0];
  const excl = hero ? [hero.split("/").pop()] : [];
  const resto = seq(catData.carpeta, 200, excl).filter((f) => f !== hero);
  const fotos = [hero, ...resto].filter(Boolean);

  return (
    <div data-testid={`pagina-galeria-${cat}`}>
      <Hero pre={p.hero.pre} titulo={textos.titulo} fotos={[hero]} testid={`hero-galeria-${cat}`} />

      <section className="py-16 md:py-24" data-testid={`gc-presentacion-${cat}`}>
        <div className="mx-auto max-w-3xl px-6 md:px-10 text-center">
          <Reveal>
            <Pretitulo>{textos.pre}</Pretitulo>
            <p className="mt-6 text-[15.5px] leading-relaxed text-ink-soft">{textoCompleto}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28" data-testid={`gc-grid-${cat}`}>
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <GaleriaGrid fotos={fotos} columnas={5} testid={`gc-grid-${cat}-grid`} />
        </div>
      </section>
    </div>
  );
}